const CryptoJS = require("crypto-js");
const SECRET_KEY = 'FenixPos2024';

const encrypt = (data) => {
    const encrypted = CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
    return encrypted;
};

const decrypt = (encryptedData) => {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedData;
};

export { encrypt, decrypt };